import React from 'react';
import { Link } from 'react-router-dom';

import { useScreenState } from '@gogame/screens';

const LinkRouter = ({ children, to, ...props }) => {
  const { version } = useScreenState();
  return (
    <Link to={version ? `${to}?version=${version}` : to} {...props}>
      {children}
    </Link>
  );
};

export default LinkRouter;
